export default __webpack_public_path__ + "static/mainscreen-390d476b8043cf70d709c569987d0c64.png";